import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Transfer2 = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.946 5.936a.9.9 0 1 0-1.272-1.272L6.066 14.27l-.198-2.98a.9.9 0 0 0-1.796.119l.33 4.96a.9.9 0 0 0 1.534.576l11.01-11.01Zm2.652 1.694a.9.9 0 0 0-1.534-.576l-11.01 11.01a.9.9 0 0 0 1.272 1.272l9.608-9.607.198 2.98a.9.9 0 0 0 1.796-.119l-.33-4.96Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Transfer2
